export default __webpack_public_path__ + "static/hero2-53cf5047a844811c5f179e5b5bfa8dc5.mp4";